import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Divider,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Layout from "../layout/layout";
import axios from "axios";
import VmMachine from '../assets/vm-symbol.png'
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import {api}from "../services/api";


const AddOperatingSys = () => {
  const theme = useTheme();
  const [popularServices, setPopularServices] = useState([]);
  const [templateData, setTemplateData] = useState(null);
  const navigate = useNavigate(); // Initialize navigate

  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPopularServices = async () => {
      try {
        const response = await api.get("/api/Application/popularServices");
        setPopularServices(response.data);
        
      } catch (error) {
        console.error("Error fetching popular services:", error);
        setError("Failed to fetch popular services");
      }
    };

    fetchPopularServices();
  }, []);

  const handleGridClick =  () => {
    navigate('/application_template/add_template');    // try {
    //   const response = await axios.get(
    //     "http://localhost:5181/api/Application/getAllTemplate/124",
    //     {
    //       headers: {
    //         "X-CORRELATION-ID": "fd401dec-8f0b-40c7-a005-250f60b6f947",
    //         Accept: "text/plain",
    //       },
    //     }
    //   );
    //   setTemplateData(response.data);
    //   navigate('/applicationForm');
    // } catch (error) {
    //   console.error("Error fetching template data:", error);
    //   setError("Failed to fetch template data");
    // }
  };


  return (
    <Layout pageType="sideBar">
      <Box
        sx={{
          flex: 1,
          pl: 2,
          bgcolor: theme.palette.background.default,
          color: theme.palette.text.primary,
        }}
      >
        
        <Typography variant="body2" gutterBottom sx={{mt:4}}>
         Select Operating System
        </Typography>

        {error && <div className="error-message">{error}</div>}
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item key='124' xs={12} sm={3} md={4} sx={{display:'flex', justifyContent:"space-between", alignItems:"center"}}>
              <Box sx={{ p: 2, textAlign: 'center', display:'flex', justifyContent:'space-between', alignItems:"center", border: `2px solid ${theme.palette.borderColor.cardborder}`, cursor:"pointer" , borderRadius:'8px'}}
              onClick={() => handleGridClick()}>
               
                <img
                  src={VmMachine}
                  alt='Virtual Machine'
                  style={{ width: "50px", height: "50px", marginRight: "10px" }}
                  onError={(e) => e.target.style.display = 'none'}
                />
                 <Typography variant="h6">Windows</Typography>
              </Box>
              <Box sx={{ p: 2,mx:2, textAlign: 'center', display:'flex',borderRadius:'8px', justifyContent:'space-between', alignItems:"center",border: `2px solid ${theme.palette.borderColor.cardborder}`, cursor:"pointer" }}
              onClick={() => handleGridClick()}>
               
                <img
                  src={VmMachine}
                  alt='Virtual Machine'
                  style={{ width: "50px", height: "50px", marginRight: "10px" }}
                  onError={(e) => e.target.style.display = 'none'}
                />
                 <Typography variant="h6">Linux</Typography>
              </Box>
              <Box sx={{ p: 2,mx:2, textAlign: 'center', display:'flex', justifyContent:'space-between', alignItems:"center", bgcolor:theme.palette.background.main, 
              border: `2px solid ${theme.palette.borderColor.cardborder}`,borderRadius:'8px',cursor:"pointer" }}
              onClick={() => handleGridClick()}>
               
                <img
                  src={VmMachine}
                  alt='Virtual Machine'
                  style={{ width: "50px", height: "50px", marginRight: "10px" }}
                  onError={(e) => e.target.style.display = 'none'}
                />
                 <Typography variant="h6">Ubuntu</Typography>
              </Box>
            </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default AddOperatingSys;
